module.exports = "<iframe [id]=\"frameId\" [src]=\"externalSessionUrl\" style=\"width:0;height:0;border:0; border:none;\"></iframe>\n"